import { FormikProps } from 'formik';
import { useTranslation } from 'react-i18next';

import { FormField } from 'components/form/formField/formField';
import { Input } from 'components/inputs';

import { LABELS } from '../../../keys';
import { Label, Section } from '../../form.styles';
import { ACHFormField, ACHFormValues, FORM_FIELDS } from '../ach.keys';

interface IndividualAccountOwnerFormProps {
  form: FormikProps<ACHFormValues>;
  onFormChange: (field: ACHFormField) => (value: string) => void;
  getFieldError: (field: ACHFormField) => string | undefined;
}

const BusinessAccountOwnerForm = ({ form, onFormChange, getFieldError }: IndividualAccountOwnerFormProps) => {
  const { t } = useTranslation();

  return (
    <Section>
      <Label>{t(LABELS.CREATE_MODAL.SECTIONS.BUSINESS_NAME_SECTION.TITLE)}</Label>
      <FormField error={getFieldError(FORM_FIELDS.BUSINESS_NAME)}>
        <Input
          placeholder={t(LABELS.CREATE_MODAL.FORM_FIELDS.PLACEHOLDERS.BUSINESS_NAME)}
          value={form.values[FORM_FIELDS.BUSINESS_NAME]}
          onChange={onFormChange(FORM_FIELDS.BUSINESS_NAME)}
        />
      </FormField>
    </Section>
  );
};

export default BusinessAccountOwnerForm;
